export const Environment = {
  Local: "local",
  Development: "development",
  Test: "test",
  Prod: "prod",
} as const;

export type Environment = (typeof Environment)[keyof typeof Environment];

export interface RuntimeConfig {
  AGREEMENT_BACKEND_URL?: string;
  HOTELS_ORG_ID?: string;
  BRISTOL_ORG_ID?: string;
  FLEX_ORG_ID?: string;
  ENVIRONMENT?: Environment;
  FRONTEND_BASE_URL?: string;
}

declare global {
  interface Window {
    RUNTIME_CONFIG?: RuntimeConfig;
  }
}
